import { FC } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import Button from 'src/components/Button';
import ModalLayoutBase, { MobileModalType, ModalFooter, ModalHeader as ModalHeaderBase, ModalTitle } from 'src/components/ModalLayout';
const ModalLayout = styled(ModalLayoutBase)`
  width: 400px;
`;
const ModalHeader = styled(ModalHeaderBase)`
  ${({
  theme
}) => theme.screenSize.mobile} {
    padding: 24px;
  }
`;
const ErrorTitle = styled(ModalTitle)`
  font-weight: 700;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0px;

  color: ${({
  theme
}) => theme.color.content12};
`;
const ErrorDescription = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: ${({
  theme
}) => theme.color.content10};
`;
interface Props {
  title?: string;
  description?: string;
  onRetry: () => void;
  onClose?: () => void;
}
const ErrorRetryModal: FC<Props> = ({
  title,
  description,
  onRetry,
  onClose
}) => {
  const {
    t
  } = useTranslation();
  return <ModalLayout onClose={onClose} mobileType={MobileModalType.BOTTOM_SHEET} isDim data-sentry-element="ModalLayout" data-sentry-component="ErrorRetryModal" data-sentry-source-file="index.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        <ErrorTitle data-sentry-element="ErrorTitle" data-sentry-source-file="index.tsx">{t(title ?? 'face_verification_error_title')}</ErrorTitle>
        <ErrorDescription data-sentry-element="ErrorDescription" data-sentry-source-file="index.tsx">{t(description ?? 'common__try_again')}</ErrorDescription>
      </ModalHeader>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <Button id='Error_Retry_Button' onClick={onRetry} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {t('WEB_VIEW__RETRY')}
        </Button>
      </ModalFooter>
    </ModalLayout>;
};
export default ErrorRetryModal;